<div class="timecard-search-select-list layout-column" appBringozIdGenerator="searchSelectList">

  <!--Search Box-->
  <div class="layout-row padding-10">
    <bz-search-input class="flex"
                     appBringozIdGenerator="searchSelectInput"
                     [placeholder]="searchLabel() | translate"
                     [ariaLabel]="searchLabel() | translate"
                     [value]="queryString()"
                     (valueChange)="onQueryChange($event)">
    </bz-search-input>
  </div>

  @if (isInitialLoading()) {
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-spinner size="lg" [label]="'Loading' | translate"></bz-spinner>
    </div>
  } @else if (isEmpty()) {
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-empty-state [title]="emptyLabel() | translate"></bz-empty-state>
    </div>
  } @else {
    <div class="flex layout-column overflow-auto search-select-items" (scroll)="onScroll($event)">
      <bz-radio-group name="searchSelectOptions"
                      appBringozIdGenerator="searchSelectOptions"
                      [value]="selectedId()"
                      [ariaLabel]="listLabel() | translate"
                      (valueChange)="onSelectId($event)">
        @for (item of items(); track item.id) {
          <bz-radio class="search-select-item" [value]="item.id">{{ item.label }}</bz-radio>
        }
      </bz-radio-group>
    </div>
  }

  <!--Next Page Loading State-->
  @if (isLoading() && !isInitialLoading()) {
    <div class="layout-row layout-align-center-center padding-5">
      <bz-spinner size="sm" [label]="'Loading' | translate"></bz-spinner>
    </div>
  }

</div>
